import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard';
import { RoleGuard } from './guards/role.guard';
import { EntryPointComponent } from './views/entry-point/entry-point.component';
import { PermissionsEnum } from './enums/PermissionsEnum';
import { ViewPath } from './constants/ViewPath';

export const routes: Routes = [
  /** No Auth routes */
  {
    path: 'login',
    title: 'Backoffice | Login',
    loadComponent: () => import('./views/login/login').then((mod) => mod.Login),
  },

  {
    path: '',
    title: 'Backoffice',
    component: EntryPointComponent,
    canActivate: [authGuard, RoleGuard],
    children: [
      //path: '', title: 'Dashboard',  loadComponent: () => import('./views/entry-point/entry-point.component').then(m => m.EntryPointComponent), },
      {
        path: 'other',
        title: 'Other',
        loadComponent: () =>
          import('./views/other-component/other-component').then((m) => m.OtherComponent),
      },
      {
        path: ViewPath.profile.path,
        title: 'Backoffice | Mi Perfil',
        loadComponent: () =>
          import('./views/user-details/user-details.component').then((m) => m.UserDetailsComponent),
        data: {},
      },
      /*{
                path: ViewPath.profile.path,
                title: 'Perfil',
                loadComponent: () => import('./views/profile/profile').then(m => m.Profile), 
                data: { profile: true },
            },*/
      {
        path: 'clients',
        title: 'Backoffice | Subscripciones',
        loadComponent: () =>
          import('./views/subscriptions/subscriptions').then((m) => m.Subscriptions),
        data: {
          permissions: [PermissionsEnum.CLIENT_READ_LIST],
        },
      },
      {
        path: 'client-details',
        title: 'Backoffice | Detalle de Cliente',
        loadComponent: () =>
          import('./views/client-details/client-details.component').then(
            (m) => m.ClientDetailsComponent,
          ),
        data: {
          permissions: [PermissionsEnum.CLIENT_READ_DETAIL],
        },
      },
      {
        path: 'users',
        title: 'Backoffice | Usuarios',
        loadComponent: () => import('./views/users/users').then((m) => m.Users),
        data: {
          permissions: [PermissionsEnum.USER_READ_LIST],
        },
      },
      {
        path: 'user-details',
        title: 'Backoffice | Detalle del Usuario',
        loadComponent: () =>
          import('./views/user-details/user-details.component').then((m) => m.UserDetailsComponent),
        data: {
          permissions: [PermissionsEnum.USER_READ_DETAIL],
        },
      },
      {
        path: 'modules',
        title: 'Backoffice | Módulos',
        loadComponent: () => import('./views/modules/modules').then((m) => m.Modules),
        data: {
          permissions: [PermissionsEnum.MODULE_READ_LIST],
        },
      },
      {
        path: 'module-details',
        title: 'Backoffice | Módulo de compañía',
        loadComponent: () =>
          import('./views/module-details/module-details.component').then((m) => m.ModuleDetails),
        data: {
          permissions: [PermissionsEnum.MODULE_READ_DETAIL],
        },
      },
      {
        path: 'billing-charges',
        title: 'Backoffice | Pre Facturas',
        loadComponent: () =>
          import('./views/billing-charges/billing-charges').then((m) => m.BillingCharges),
        data: {
          permissions: [PermissionsEnum.INVOICE_READ_LIST],
        },
      },
      {
        path: 'billing-charge-details',
        title: 'Backoffice | Detalle de Pre Factura',
        loadComponent: () =>
          import('./views/billing-charge-details/billing-charge-details.component').then(
            (m) => m.BillingChargeDetailsComponent,
          ),
        data: {
          permissions: [PermissionsEnum.INVOICE_READ_DETAIL],
        },
      },
      {
        path: 'dashboard',
        title: 'Backoffice | Dashboard',
        loadComponent: () => import('./views/dashboard/dashboard').then((m) => m.Dashboard),
        data: {
          permissions: [PermissionsEnum.BACKOFFICE_READ_DASHBOARD],
        },
      },
      {
        path: 'public-chat-analytics',
        title: 'Backoffice | Análisis del chat público',
        loadComponent: () =>
          import('./views/public-chat-analytics/public-chat-analytics').then(
            (m) => m.PublicChatAnalytics,
          ),
        data: { permissions: [PermissionsEnum.CLIENT_READ_COMMUNICATION] },
      },
      {
        path: 'public-chat-conversations',
        title: 'Backoffice | Conversaciones del chat público',
        loadComponent: () =>
          import('./views/public-chat-conversations/public-chat-conversations').then(
            (m) => m.PublicChatConversations,
          ),
        data: { permissions: [PermissionsEnum.CLIENT_READ_COMMUNICATION] },
      },
      {
        path: 'public-chat-conversation',
        title: 'Backoffice | Conversación del chat público',
        loadComponent: () =>
          import('./views/public-chat-conversation/public-chat-conversation').then(
            (m) => m.PublicChatConversation,
          ),
        data: { permissions: [PermissionsEnum.CLIENT_READ_COMMUNICATION] },
      },
      {
        path: 'commercial-calculator',
        title: 'Backoffice | Calculadora Comercial',
        loadComponent: () =>
          import('./views/commercial-calculator/commercial-calculator.component').then(
            (m) => m.CommercialCalculatorComponent,
          ),
      },
      {
        path: 'internal-logs',
        title: 'Backoffice | Logs Internos',
        loadComponent: () =>
          import('./views/internal-logs/internal-logs').then((m) => m.InternalLogsComponent),
        data: {
          permissions: [PermissionsEnum.LOG_READ_INTERNAL],
        },
      },
      {
        path: 'eina-logs',
        title: 'Backoffice | Logs de Eina',
        loadComponent: () => import('./views/eina-logs/eina-logs').then((m) => m.EinaLogsComponent),
        data: {
          permissions: [PermissionsEnum.LOG_READ_EINA],
        },
      },
      {
        path: 'system-logs',
        title: 'Backoffice | Logs de Sistema',
        loadComponent: () =>
          import('./views/system-logs/system-logs').then((m) => m.SystemLogsComponent),
        data: {
          permissions: [PermissionsEnum.LOG_READ_SYSTEM],
        },
      },
      {
        path: 'error-logs',
        title: 'Backoffice | Logs de Error',
        loadComponent: () => import('./views/error-logs/error-logs').then((m) => m.ErrorLogs),
        data: {
          permissions: [PermissionsEnum.LOG_READ_ERROR],
        },
      },
      {
        path: 'feedback',
        title: 'Backoffice | Encuestas',
        loadComponent: () => import('./views/feedback/feedback').then((m) => m.Feedback),
      },
      {
        path: 'feedback-details',
        title: 'Backoffice | Detalle de Encuesta',
        loadComponent: () =>
          import('./views/feedback-details/feedback-details.component').then(
            (m) => m.FeedbackDetailsComponent,
          ),
      },
      {
        path: ViewPath.importStatus.path,
        title: 'Backoffice | Estado de Importaciones',
        loadComponent: () =>
          import('./views/import-status/import-status').then((m) => m.ImportStatus),
        data: {
          permissions: [PermissionsEnum.IMPORT_READ_STATUS],
        },
      },
      {
        path: ViewPath.endpointTimings.path,
        title: 'Backoffice | Rendimiento',
        loadComponent: () =>
          import('./views/endpoint-timings/endpoint-timings.component').then(
            (m) => m.EndpointTimingsComponent,
          ),
        data: {
          permissions: [PermissionsEnum.BACKOFFICE_READ_ENDPOINT_TIMINGS],
        },
      },
      {
        path: ViewPath.companyTokens.path,
        title: 'Backoffice | Tokens de compañía',
        loadComponent: () =>
          import('./views/company-tokens/company-tokens.component').then(
            (m) => m.CompanyTokensComponent,
          ),
      },
      {
        path: ViewPath.developerBranch.path,
        title: 'Backoffice | Ramas',
        loadComponent: () =>
          import('./views/developer/developer-branch/developer-branch').then(
            (m) => m.DeveloperBranchComponent,
          ),
        data: {
          permissions: [PermissionsEnum.DEVELOPER_READ_BRANCHES],
        },
      },
      {
        path: ViewPath.developerDatabase.path,
        title: 'Backoffice | Base de datos',
        loadComponent: () =>
          import('./views/developer/developer-database/developer-database').then(
            (m) => m.DeveloperDatabaseComponent,
          ),
        data: {
          permissions: [PermissionsEnum.DEVELOPER_READ_DATABASE],
        },
      },
    ],
  },

  {
    path: '**',
    pathMatch: 'full',
    title: 'Error',
    loadComponent: () =>
      import('./views/page-not-found/page-not-found').then((mod) => mod.PageNotFound),
  },
];
